module.exports = __webpack_public_path__ + "static/img/Aaclogomax1.2ee82f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aaclogomax1.png
// module id = 08nB
// module chunks = 1